import { Spin } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { MdShoppingCart } from "react-icons/md";
import { CURRENCY_SYMBOL, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import CartModal from "./Modal";

function Cart({ project, generalCost, updateStatus, loading, upsells = [] }) {
  const [open, setOpen] = useState(false);
  const totalAmount = upsells
    .reduce((acc, { cost }) => (acc += cost), get(generalCost, "cost", 0))
    .toFixed(2);
  const onSubmit = () => {
    updateStatus({
      template:
        TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY].PRODUCTS,
    });
  };

  const onClose = () => setOpen(false);

  const onOpen = () => setOpen(true);

  return (
    <>
      <button type="button" className="miltis-navbar__cart" onClick={onOpen}>
        {loading ? (
          <Spin size="small" />
        ) : (
          <>
            <MdShoppingCart size={24} className="miltis-navbar__cart-icon" />
            <span className="miltis-navbar__cart-price">
              {costToFrench(totalAmount)}
            </span>
            <span className="miltis-navbar__cart-currency">
              {CURRENCY_SYMBOL[generalCost?.currency] || "€"}{" "}
              <span className="miltis-navbar__cart-period">/mois</span>
            </span>
          </>
        )}
      </button>
      <CartModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        generalCost={generalCost}
        project={project}
        totalAmount={totalAmount}
        upsells={upsells}
      />
    </>
  );
}

export default Cart;
